import './App.css';

import React from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";
import Home from "./pages";
import Freeship from "./pages/freeship";
import Sameday from "./pages/sameday";
import Pickupconfig from "./pages/pickupconfig";
import Login from "./pages/login";
import Registration from "./pages/registration";
import Navbar from './components/Navbar';


function App() {
  return (
    <Router>
        <div className="site-main">
            <Navbar />
            <div className="content-main">
                <Routes>
                    <Route exact path="/" element={<Home />} />
                    <Route path="/freeship" element={<Freeship />} />
                    <Route path="/sameday" element={<Sameday />} />
                    <Route path="/pickupconfig" element={<Pickupconfig />} />
                    <Route path="/registration" element={<Registration />} />
                    <Route path="/login" element={<Login />} />
                </Routes>
            </div>
        </div>
    </Router>
  );
}

export default App;
